import { render, staticRenderFns } from "./TableSavePosition.vue?vue&type=template&id=6722beb8"
import script from "./TableSavePosition.vue?vue&type=script&lang=js"
export * from "./TableSavePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports